import { render } from "./InvoiceNotes.vue?vue&type=template&id=b0b0a864&ts=true"
import script from "./InvoiceNotes.vue?vue&type=script&lang=ts"
export * from "./InvoiceNotes.vue?vue&type=script&lang=ts"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__